
import React from "react";
import { Box, Typography } from "@mui/material";

const BenefitsFeature = ({
  number,
  title,
  description,
  image,
}) => {
  const words = title.split(" ");
  const lastWord = words.pop();
  const firstWords = words.join(" ");

  return (
    <Box className="benefit-card">
      {/* Text Content */}
      <Box className="benefit-card-content">
        <Typography className="benefit-card-number">
          {String(number).padStart(2, "0")}
        </Typography>

        <Box className="benefit-card-divider" />

        <Typography className="benefit-card-title">
          {firstWords}{" "}
          <Box
            component="span"
            sx={{
              color: "#000",
              fontSize: "26px",
            }}
          >
            {lastWord}
          </Box>
        </Typography>

        <Typography className="benefit-card-description">
          {description}
        </Typography>
      </Box>

      {/* Image */}
      <Box className="benefit-card-image-wrapper">
        <Box
          component="img"
          src={image}
          alt={title}
          className="benefit-card-image"
        />
      </Box>
    </Box>
  );
};

export default BenefitsFeature;